import { Checkbox, getTheme, Stack, Text, TooltipHost, ICheckboxStyles } from '@fluentui/react';
import * as React from 'react';

const { palette } = getTheme();

export interface LabelListItemProps {
  key: string;
  label: string;
  disabled: boolean;
  onClick(): void;
}

export interface LabelListItemState {
  style: React.CSSProperties;
  selected: boolean;
}

const wrapperDefaultStyle: React.CSSProperties = {
  border: '2px solid ' + palette.neutralLight
};

const wrapperSelectedStyle: React.CSSProperties = {
  border: '2px solid ' + palette.themePrimary
};

const wrapperDisabledStyle: React.CSSProperties = {
  // background: palette.neutralQuaternaryAlt,
  background: palette.neutralTertiaryAlt,
  color: 'red',
  border: '2px solid ' + palette.neutralQuaternaryAlt,
  pointerEvents: 'none'
};

const styleCheckbox: ICheckboxStyles = {
  root: {
    paddingTop: '5%',
    width: '20px',
    height: '20px'
  }
};

const labelMaxSize = 20; // Maximun size of label before adding '...' and tooltip.

export class LabelListItem extends React.PureComponent<LabelListItemProps, LabelListItemState> {
  constructor(props) {
    super(props);
    this.state = {
      style: wrapperDefaultStyle,
      selected: false
    };
  }

  render(): JSX.Element {
    let currentStyle = this.state.style;
    if (this.props.disabled) {
      currentStyle = wrapperDisabledStyle;
    }
    return (
      <Stack
        onMouseOver={(): void => this.onMouseEnter()}
        onMouseOut={(): void => this.onMouseOut()}
        onClick={(event): void => this.onClick(event)}
        className="p-2"
        style={currentStyle}
        horizontal
        tokens={{ childrenGap: 10 }}
      >
        <Stack.Item>
          <Checkbox ariaLabel={`${this.props.label}`} styles={styleCheckbox} checked={this.state.selected} />
        </Stack.Item>
        <Stack.Item>
          {this.props.label.length <= labelMaxSize ? (
            <Text variant="mediumPlus">{this.props.label}</Text>
          ) : (
            <TooltipHost content={this.props.label}>
              <Text variant="mediumPlus">{this.props.label.slice(0, labelMaxSize) + '...'}</Text>
            </TooltipHost>
          )}
        </Stack.Item>
      </Stack>
    );
  }

  private onMouseEnter(): void {
    if (!this.props.disabled && !this.state.selected) {
      this.setState({
        style: wrapperSelectedStyle
      });
    }
  }

  private onMouseOut(): void {
    if (!this.props.disabled && !this.state.selected) {
      this.setState({
        style: wrapperDefaultStyle
      });
    }
  }

  private onClick(event: React.MouseEvent<HTMLElement, MouseEvent>): void {
    // Preventing checkbox from triggering click twice
    event.preventDefault();
    if (!this.props.disabled) {
      if (this.state.selected) {
        this.setState({
          style: wrapperDefaultStyle,
          selected: false
        });
      } else {
        this.setState({
          style: wrapperSelectedStyle,
          selected: true
        });
      }
    }
    this.props.onClick();
  }
}
